export const config = {
    API_URL: "https://core-engine.eleti.dev",
    APP_URL: "https://chatai.eleti.dev/",
    SOCKET_URL: 'https://response-stream.eleti.dev',
    ENV: "prod",
}